import type { ReadConfig } from 'api-read-hook';
import type { HydraCollection } from '../../types';

import { useApiRead } from 'api-read-hook';

import { makeQueryString } from '../../util';

export type V = {
  '@id': string;
  '@type': 'EnvironmentDeploymentCommit';
  hash: string;
  title: string;
  author: string;
  timestamp: string;
  checkStatus: string | null;
};

export function useReadCollectionCommits(
  deploymentId: string,
  queryParams?: { page?: number },
  options?: ReadConfig
) {
  return useApiRead<HydraCollection<V>>(
    `/environment-deployments/${deploymentId}/commits${makeQueryString(
      queryParams
    )}`,
    options
  );
}
